export const lang = {
  home: {
    home:"首页",
    work:"工作",
    about:"关于",
    teams:"团队",

    Summit: "Summit Wealth Investment Education Foundation",
    theSummit:
      "Summit Wealth Investment Education Foundation（简称SW IEF）成立于2019年，由一群金融教育专家、投资专业人士和科技创业者共同创立。随着全球金融市场的快速发展和复杂化，投资者对金融知识和技能的需求日益增加。SW IEF旨在通过提供高质量的投资教育资源和平台，提升公众的金融素养，帮助投资者做出明智的投资决策。",
    WhitePaper: "白皮书",
    core: "SW IEF的核心使命是：",
    Enhancing:
      "• 提升金融素养：通过教育和培训，帮助公众了解金融市场的基本运作和投资策略，提升其金融素养。",
    Promoting:
      "• 推动金融创新：利用区块链和人工智能等先进技术，推动金融教育的数字化和智能化，提高教育的覆盖面和效果。",
    Fostering:
      "• 促进社会公平：致力于缩小金融知识的鸿沟，提供公平的教育机会，让更多人能够受益于金融市场的发展。",
    Protecting:
      "• 保护投资者权益：提供全面的风险教育，帮助投资者识别和防范投资风险，保护其合法权益。",

    Features: "模型特点",

    Driven:
      "• AI驱动：FINQbot利用机器学习和自然语言处理技术，从海量数据中提取关键信息，提供精准的市场分析和投资建议。",
    Real:
      "• 实时数据处理：基于先进的算法，FINQbot能够实时处理和分析金融市场动态，确保用户始终掌握最新的市场信息。",
    Personalized:
      "• 个性化定制：根据用户的投资风格和风险偏好，FINQbot可以提供量身定制的投资策略和建议。",

    FINQbot: "FINQbot 介绍",
    Introduction:
      "FINQbot是一款由Summit Wealth Investment Education Foundation精心研发的先进金融科技产品，旨在为全球投资者提供智能化、自动化和个性化的金融服务。作为一个“机器人”，FINQbot能够自动执行预设的交易策略和投资计划，减少人工操作的误差，并全天候提供市场监控和投资建议，确保用户在任何时间都能获得最佳的投资机会。",

    Token: "代币",
    Name: "代币名称：SIW ",

    Total: "总发行量：3亿枚",

    Foundation: "投教基金会国库：10%",
    Technical: "项目技术团队：5%",
    Project: "FINQbot项目：40%",
    Circulation: "STO流通项目：30%",
    Airdrop: "市场行销空投：15% ",

    team: "我们的团队",

    Wealth:
      "Summit Wealth Investment Education Foundation团队由一群充满激情、经验丰富的专业人士组成，他们在各自的领域内都有着卓越的成就和深厚的积累。我们坚信，在他们的共同努力下，SW IEF将不断突破创新，为全球投资者提供最优质的教育资源和技术支持。",

    Pedro: "Pedro Hill：创始人 & 导师",

    CTO: "Rafferty Finnegan: CTO",
    COO: "Thaddeus Hawthorne: COO",
    Augustine: "Augustine Callahan: 金牌导师",

    Cooperate: "合作",
    partners: "我们的伙伴",
  },
};
